import { WhitelabelConfig } from '@whitelabel/types';

const PricelineWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Priceline',
    termsOfUseUrl: 'https://www.trvl.priceline.com/info/termsofuse.html',
    privacyPolicyUrl: 'https://www.trvl.priceline.com/info/privacy.html',
};

export default PricelineWhitelabelConfig;
